// extracted by mini-css-extract-plugin
module.exports = {"file_item":"FileItem_file_item__uRX1x","close_icon":"FileItem_close_icon__uBRBe","timestamp":"FileItem_timestamp__bBitm"};